module.exports = __webpack_public_path__ + "static/img/bjk_gywm_icon.png";